module.exports = __webpack_public_path__ + "media/images/common/ordermail_btn_l-b23df19d431acd030ab01f5d18b12302.png";